var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-100 height-100 flex-centerize"},[(_vm.isLoading)?_c('AppLoader'):(_vm.showErrorMessage)?_c('div',[_vm._v("Something went wrong. Please try again later")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }